import { Grid } from "@mui/material";
import { HeaderGrid } from "components/atoms/HeaderGrid";
import { useNavigate, useParams } from "react-router-dom";
import { useQueryWithSnack } from "utils/useQueryWithSnack";
import { DisinfectionsByRoomTable } from "../organisms/charts/DisinfectionsByRoomTable";
import { ORG_QUERY } from "./UserPage";

export const RoomsPage = () => {
  const { orgId } = useParams();
  const navigate = useNavigate();

  const { data: orgData } = useQueryWithSnack(ORG_QUERY, {
    variables: { orgId: orgId ?? "" },
    skip: !orgId || orgId === "support",
  });

  return (
    <Grid container spacing={6}>
      <HeaderGrid
        crumbs={
          location.pathname.includes("support")
            ? [
                { label: "Support" },
                {
                  label: "Organizations",
                  onClick: () => navigate(`/cloud/support/organizations`),
                },
                {
                  label: orgId && orgData ? orgData?.organization.name : "-",
                  onClick: () =>
                    navigate(`/cloud/support/organizations/${orgId}`),
                },
                {
                  label: "Rooms",
                },
              ]
            : [
                {
                  label: orgId && orgData ? orgData?.organization.name : "-",
                },
                {
                  label: "Rooms",
                },
              ]
        }
      />
      <Grid item xs={12}>
        <DisinfectionsByRoomTable />
      </Grid>
    </Grid>
  );
};
